import * as THREE from 'three'
import { Instance } from 'mobx-state-tree'
import { IPrintedcircuitboard } from './types'

type IPrintedcircuitboardInstance = Instance<IPrintedcircuitboard>

type PlaceHolderGeometryProps = {
  position: 'up' | 'down'
  properties: Pick<IPrintedcircuitboardInstance['properties'], 'width' | 'length' | 'thickness'> & {
    border:
      | IPrintedcircuitboardInstance['properties']['componentSide']['border']
      | IPrintedcircuitboardInstance['properties']['solderSide']['border']
    element:
      | IPrintedcircuitboardInstance['properties']['componentSide']['height']
      | IPrintedcircuitboardInstance['properties']['solderSide']['height']
  }
}

export const buildPlaceholderGeometry = ({
  position,
  properties: {
    width: { value: width },
    length: { value: length },
    thickness: { value: thickness },
    //
    element: { value: element },
    border: {
      top: { value: top },
      right: { value: right },
      left: { value: left },
      bottom: { value: bottom }
    }
  }
}: PlaceHolderGeometryProps): THREE.BufferGeometry => {
  const boxWidth = width - right - left
  const boxHeight = length - bottom - top

  // TODO if some boxproperty is > 0 use a PlaneBufferGeometry instead of a box
  let geometry
  if (element > 0) {
    geometry = new THREE.BoxBufferGeometry(
      boxWidth >= 0 ? boxWidth : 0,
      boxHeight >= 0 ? boxHeight : 0,
      element
    )
  } else {
    geometry = new THREE.PlaneBufferGeometry(
      boxWidth >= 0 ? boxWidth : 0,
      boxHeight >= 0 ? boxHeight : 0
    )
  }
  geometry
    .translate(
      (width - boxWidth) / 2 - right,
      (length - boxHeight) / 2 - bottom,
      position === 'up' ? -element / 2 - thickness / 2 : element / 2 + thickness / 2
    )
    .rotateX(Math.PI / 2)
    .rotateY(Math.PI / 2)

  return geometry
}
